import React from 'react';
import { Spin, Typography } from 'antd';
import CarCards from '../CarCards/CarCards';
import { Car } from '../../types/home';

const { Title } = Typography;

interface TopPicksSectionProps {
  loading: boolean;
  error: string | null;
  cars: Array<Car>;
  carsLength: number;
  starToggle: string;
  setStarChanged: (starChanged: boolean) => void;
  setDataSource: (cars: Array<Car>) => void;
  onNavigateToDetails: () => void;
}

const TopPicksSection: React.FC<TopPicksSectionProps> = ({
  loading,
  error,
  cars,
  carsLength,
  starToggle,
  setStarChanged,
  setDataSource,
  onNavigateToDetails
}) => {
  return (
    <div className="car-cards-wrapper">
      <Title level={2} className="section-header">
        Auctions
      </Title>
      {loading ? (
        <div className="loading-spinner">
          <Spin tip="Loading top picks..." />
        </div>
      ) : (
        <CarCards
          page={1}
          itemsPerPage={6}
          dataSource={cars}
          carsLength={carsLength}
          onPageChange={() => {}}
          setDataSource={setDataSource}
          starToggle={starToggle}
          setStarChanged={setStarChanged}
          onNavigateToDetails={onNavigateToDetails}
          pages={false}
        />
      )}
    </div>
  );
};

export default TopPicksSection;
